import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MenuItemService {

  constructor() { }
  
  private readonly navBarSelect = new BehaviorSubject(0);
  private readonly navBarSecondarySelect = new BehaviorSubject(0);

  /** For observ the value of select navbar */
  public setNavbarSelect(isNavBarSelect: number): void {
    localStorage.setItem('navBarSelect', isNavBarSelect.toString());
    this.navBarSelect.next(isNavBarSelect);
  }

  /** For get the value of selected navbar */
  public get getsetNavbarSelectAction$(): Observable<number> {
    return this.navBarSelect.asObservable();
  }

  /**
   * Know if the item of menu selected is a child, and if is this, set the value of pattern
   * @param order Value of order of item selected
   * @returns: Value of patter or item when not has children 
   */
  public checkIfOrderIsAChild(order: number): number {
    let value: number = order;
    if(order >= 20 && order <= 29) {
      value = 2;
      this.setNavbarSecondarySelect(order);
    } else {
      this.cleanNavbarSecondarySelect();
    }
    return value;
  }

  /** For observ the value of select navbar secondary */
  public setNavbarSecondarySelect(isNavBarSecondarySelect: number): void {
    localStorage.setItem('navBarSecondarySelect', isNavBarSecondarySelect.toString());
    this.navBarSecondarySelect.next(isNavBarSecondarySelect);
  }

  /** For get the value of selected navbar secondary */
  public get getsetNavbarSelectSecondaryAction$(): Observable<number> {
    return this.navBarSecondarySelect.asObservable();
  }

  /** For when before selected a child, and after select a father, clean the children */
  private cleanNavbarSecondarySelect(): void {
    this.setNavbarSecondarySelect(-1);
    localStorage.setItem('navBarSecondarySelect', '-1');
  }

}
